// ** Initial user ability
export const initialAbility = []

export const _ = undefined
